import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeTab: "mice",
  activeEventStep: 0,
  activeMiceStep: 0,
  eventWorkflow: {},
  imageWorkflow: {},
  reviewWorkflow: {},
  selectedEvent: {},
  activePackagesTab: "New request",
  isDownloading: false,
  eventWorkflowStatus: [],
  imageWorkflowStatus: [],
  reviewWorkflowStatus: [],
  notification: false,
  activeEventBreakDownTab: "Day 1"
};

export const eventSlice = createSlice({
  name: "event",
  initialState: initialState,
  reducers: {
    activeEventTab: (state, action) => {
      return { ...state, activeTab: action.payload };
    },
    activePackagesTab: (state, action) => {
      return { ...state, activePackagesTab: action.payload };
    },
    changeEventStep: (state, action) => {
      return { ...state, activeEventStep: action.payload };
    },
    changeMiceStep: (state, action) => {
      return { ...state, activeMiceStep: action.payload };
    },
    setEventWorkflow: (state, action) => {
      return { ...state, eventWorkflow: action.payload };
    },
    setImageWorkflow: (state, action) => {
      return { ...state, imageWorkflow: action.payload };
    },
    setReviewWorkflow: (state, action) => {
      return { ...state, reviewWorkflow: action.payload };
    },
    setSelectedEvent: (state, action) => {
      return { ...state, selectedEvent: action.payload };
    },
    setEventWorkflowStatus: (state, action) => {
      return { ...state, eventWorkflowStatus: action.payload };
    },
    setImageWorkflowStatus: (state, action) => {
      return { ...state, imageWorkflowStatus: action.payload };
    },
    setReviewWorkflowStatus: (state, action) => {
      return { ...state, reviewWorkflowStatus: action.payload };
    },
    setNotification: (state, action) => {
      return { ...state, notification: action.payload };
    },
    setActiveEventBreakDownTab: (state, action) => {
      return { ...state, activeEventBreakDownTab: action.payload };
    },
    setIsDownloading: (state, action) => {
      return { ...state, isDownloading: action.payload };
    },
    reset: () => initialState,
  },
});

export const {
  activeEventTab,
  changeEventStep,
  changeMiceStep,
  setEventWorkflow,
  setImageWorkflow,
  setReviewWorkflow,
  setSelectedEvent,
  activePackagesTab,
  setEventWorkflowStatus,
  setImageWorkflowStatus,
  setReviewWorkflowStatus,
  setNotification,
  setActiveEventBreakDownTab,
  setIsDownloading,
  reset,
} = eventSlice.actions;
export default eventSlice.reducer;
